module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_id_card_en.e0cd12615b93b5394d9cc326dac9f215.png";